import $ from 'jquery';
import lozad from 'lozad';

// hide missing images
const hideMissingImage = () => {
    const $imgs = $('img');
    $imgs.each(function () {
        const $el = $(this);
        $el
            .on('error', el => $(el.target).hide())
            .attr('src', $el.attr('src'));
    });
};

const initLazyLoading = () => {
    const observer = lozad('.lazyloading');
    observer.observe();
};

// init function
$(() => {
    hideMissingImage();
    initLazyLoading();
});



// WEBPACK FOOTER //
// ./src/js/global.js